export const config = {
    admin_user_ids: ['aqX59RalZnV1sHLpS6UA1b5b4992']
}